// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Statistics from './Statistics';
import Search from './Search';
import BatchSearch from './BatchSearch';
import Layout from './Layout';
import Help from './Help';
import Home from './Home';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import SetPassword from './SetPassword';
import RequestAccess from './RequestAccess';
import AdminAccessRequests from './AdminAccessRequests';
import { StatsProvider } from './contexts/StatsContext';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/request-access" element={<RequestAccess />} />
        <Route path="/" element={
          <StatsProvider>
            <Layout />
          </StatsProvider>
        }>
          <Route index element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/search" element={<ProtectedRoute><Search /></ProtectedRoute>} />
          <Route path="/batch-search" element={<ProtectedRoute><BatchSearch /></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute><Help /></ProtectedRoute>} />
          <Route path="/search/:productCode" element={<ProtectedRoute><Search /></ProtectedRoute>} />
          <Route path="/statistics" element={<ProtectedRoute><Statistics /></ProtectedRoute>} />
          <Route path="/admin/access-requests" element={<ProtectedRoute><AdminAccessRequests /></ProtectedRoute>} />
        </Route>
      </Routes>
    </Router>
  </AuthProvider>
);

reportWebVitals();
